<template>
  <div class="relative overflow-hidden">

    <section
      class="h-full overflow-hidden max-h-[2220px] sm:max-h-[2220px] md:max-h-[2300px] xl:max-h-[2300px] relative font-orbitron bg-gradient-to-b from-[#191822]/0 to-[#191822]"
      id="home">

      <!-- Overlays -->
      <div class="absolute inset-0 w-full h-full bg-center z-[12] bg-[#080809]/50"></div>
      <img src="@/assets/overlay-0.webp"
        class="absolute bottom-0 z-[12] hidden md:block object-cover object-center w-full h-full"
        alt="overlay 0" />
      <img src="@/assets/overlay-0-sp.png"
        class="absolute bottom-0 z-[12] block md:hidden object-cover object-center w-full h-full"
        alt="overlay 0" />
      <img src="@/assets/overlay-2.avif"
        class="absolute top-[45px] z-[12] -left-28 hidden md:block object-cover object-center w-auto h-full max-w-[200px] lg:max-w-[600px] 2xl:max-w-[811px] max-h-[990px]"
        alt="overlay 1" />
      <img src="@/assets/overlay-1.avif"
        class="absolute top-[45px] -right-28 z-[12] hidden md:block object-cover object-center w-auto h-full max-w-[200px] lg:max-w-[600px] 2xl:max-w-[811px] max-h-[990px]"
        alt="overlay 2" />
      <img src="@/assets/overlay-2-sp.png"
        class="absolute top-[45px] z-[12] -left-28 block md:hidden object-cover object-center w-full h-full max-w-[208px] lg:max-w-[600px] 2xl:max-w-[811px]"
        alt="overlay 1" />
      <img src="@/assets/overlay-1-sp.png"
        class="absolute top-[45px] -right-28 z-[12] block md:hidden object-cover object-center w-full h-full max-w-[208px] lg:max-w-[600px] 2xl:max-w-[811px]"
        alt="overlay 2" />
      <img src="@/assets/overlay-3.avif"
        class="absolute bottom-0 z-10 hidden md:block object-cover object-center w-full h-auto max-h-[637px]"
        alt="overlay 3" />
      <img src="@/assets/overlay-3-sp.png"
        class="absolute bottom-0 z-10 block md:hidden object-cover object-center w-full h-auto max-h-[238px]"
        alt="overlay 3" />
      <img src="@/assets/overlay-4.avif"
        class="absolute bottom-0 z-10 hidden md:block object-cover object-center w-full h-auto max-h-[637px]"
        alt="overlay 4" />
      <img src="@/assets/overlay-4-sp.png"
        class="absolute bottom-0 z-10 block md:hidden object-cover object-center w-full h-auto max-h-[164px]"
        alt="overlay 4" />
      <img src="@/assets/planet-1.avif"
        class="absolute top-[156px] left-3 md:left-[107px] z-[12] block object-contain w-auto h-[94px] md:h-[236px]"
        alt="planet 1" />
      <img src="@/assets/planet-2.avif"
        class="absolute top-[428px] right-3 md:right-[73px] z-[12] block object-contain w-auto h-[91px] md:h-[174px]"
        alt="planet 2" />
      <!-- Content Container -->
      <div
        class="z-30 flex flex-col items-center justify-center w-full h-full px-4 pt-14 pb-[200px] sm:px-14 lg:pt-[100px] 2xl:pt-28 md:px-0 xl:px-[120px] xl:pt-20">
        <!-- Hero Image (Responsive Display) -->
        <div
          class="flex flex-col items-center justify-center w-full md:w-[800px] lg:w-[1000px] xl:w-full h-full gap-10">

          <!-- Desktop Image -->
          <img v-motion-pop-visible src="@/assets/moonlight-logo.avif"
            class="z-20 w-[280px] sm:w-[50%] md:w-[520px] lg:w-[760px] h-auto mt-10 md:mt-0 object-contain"
            alt="desktop-title-text" />

          <!-- Hero text -->
          <img src="../assets/hero-text.avif" alt="hero text"
            class="h-10 lg:h-[60px] w-auto object-contain z-20">

          <div class="flex flex-col gap-4 lg:flex-row z-20">
            <!-- Register on Goated Button -->
            <div class="relative border-[2px] border-white rounded-2xl bg-gradient-to-r from-[#5C3EB7] to-[#2D1C63]
              overflow-hidden flex items-center justify-center shadow-[-14px_10px_44px_-20px_#FFFFFF] hover:scale-105">
              <a href="https://www.goated.com/r/MOONLIGHT" class="z-10 px-[30px] py-4 text-lg sm:text-xl md:text-2xl leading-6 font-bold text-white hero-button-text
              text-center whitespace-nowrap">
                Register on Goated.com
              </a>
              <img src="@/assets/hero-btn-style-1.png" alt="Decorative slant shadow"
                class="absolute inset-y-0 left-0 h-full pointer-events-none" />
              <img src="@/assets/hero-btn-style-2.png" alt="Decorative slant shadow"
                class="absolute inset-y-0 right-0 h-full pointer-events-none" />
            </div>
            <!-- Watch Stream at Kick Button -->
            <div class="relative border-[2px] border-white rounded-2xl bg-[#191822]
              overflow-hidden flex items-center justify-center shadow-[-14px_10px_44px_-20px_#FFFFFF] hero-button-text hover:scale-105">
              <a href="https://kick.com/moonlight2019" class="z-10 px-[30px] py-4 text-lg sm:text-xl md:text-2xl leading-6 font-bold text-white hero-button-text
              text-center whitespace-nowrap">
                Watch live on Kick.com
              </a>
              <img src="@/assets/hero-btn-style-1.png" alt="Decorative slant shadow"
                class="absolute inset-y-0 left-0 h-full pointer-events-none" />
              <img src="@/assets/hero-btn-style-2.png" alt="Decorative slant shadow"
                class="absolute inset-y-0 right-0 h-full pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <PromotionSection />
    <LeaderboardSection />
  </div>
</template>

<script>
import LeaderboardSection from "@/sections/LeaderboardSection.vue";
import PromotionSection from "@/sections/PromotionSection.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    PromotionSection,
    LeaderboardSection,
  },
  mounted() {
    this.$emit("sections-ready");
  },
});
</script>
<style>
.hero-button-text {
  -webkit-text-stroke: 2px #191822;
  opacity: 1;
  -webkit-font-smoothing: antialiased;
  @media (max-width: 1020px) {
    -webkit-text-stroke: 1px #191822;
  }

  @media (max-width: 640px) {
    -webkit-text-stroke: .5px #191822;
  }
}
</style>
